import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]

import { ref, onMounted, reactive, watch } from "vue";
import { mdmServer } from "./types";
import { apiQuery } from "@/api/j24api";
import { permissionsStore } from "@/stores/permissions";
import VSelectSearch from "@/components/VSelectSearch.vue";
//import type { PermissionObject } from "@/stores/permissions";

interface tempAccountRecords {
  _id: string;
  blockOtherAccounts: boolean;
  createdBy: string;
  customerId: string;
  elamdmserverId: string;
  permissionLevel: string;
  removed: boolean;
  scheduledRemovalTime: string;
  setupTime: string;
  username: string;
  mdmServerName?: string;
  setupTimeFormatted?: string;
  scheduledRemovalTimeFormatted?: string;
}
interface NewAccount {
  mdmServerID?: string;
  permissionLevel?: string;
  expireInMins?: string;
  username?: string;
  password?: string;
  url?: string;
  changeReference?: string;
  failoverUrl?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardAccounts',
  setup(__props) {

const permissions = permissionsStore();
permissions.$subscribe(() => {
  removePermissionLevels();
  shouldShowAccountsTab();
});

const selectedTab = ref("");

const mdmServers: mdmServer[] = reactive([]);
const accounts: tempAccountRecords[] = reactive([]);
const showAllRecords = ref(false);
const showAccountsTab = ref(false);

watch(showAllRecords, (currentValue) => {
  getData();
});

function shouldShowAccountsTab() {
  if (permissions.$state["Dashboard-TempAccountsList"]) {
    showAccountsTab.value = true;
  } else {
    showAccountsTab.value = false;
  }
}

async function getData() {
  loading.value = true;
  alertTxt.value = "";
  if (mdmServers.length == 0) {
    const result = await apiQuery("J24Auth", "elaadmin/mdmservers", {
      apiAction: "get",
    });
    if (result) {
      result.forEach((record: mdmServer) => {
        if (record.type == "Jamf") {
          mdmServers.push(record);
        }
      });
    }
  }

  shouldShowAccountsTab();
  if (showAccountsTab.value) {
    var apiAction = "listCurrent";
    if (showAllRecords.value) {
      apiAction = "listAll";
    }
    const result = await apiQuery("ELA", "ela/TemporaryJamfAccountActions", {
      apiAction: apiAction,
    });
    if (result) {
      accounts.length = 0;
      result.forEach((account: tempAccountRecords) => {
        accounts.push({
          mdmServerName: getMDMServerName(account.elamdmserverId),
          setupTimeFormatted: new Date(account.setupTime).toLocaleString(
            "en-GB"
          ),
          scheduledRemovalTimeFormatted: new Date(
            account.scheduledRemovalTime
          ).toLocaleString("en-GB"),
          ...account,
        });
      });
    }
  }

  loading.value = false;
}

function getMDMServerName(id: string) {
  var name = "";
  mdmServers.forEach((server) => {
    if (id == server._id) {
      name = server.name;
    }
  });
  return name;
}

const defaultPermissionLevels = reactive([
  "ReadOnly",
  "JamfServiceDeskL1Lower",
  "JamfServiceDeskL1",
  "JamfServiceDeskL1Higher",
  "JamfServiceDeskL2",
  "JamfServiceDeskL3",
  "JamfSDM",
]);
const permissionLevels: string[] = reactive([]);

function removePermissionLevels() {
  var newPermissionLevels: string[] = [];
  defaultPermissionLevels.forEach((permission) => {
    let permissionString = "Dashboard-TempJamfAccount" + permission;
    Object.keys(permissions.$state).forEach((key) => {
      if (key == permissionString) {
        newPermissionLevels.push(permission);
      }
    });
  });
  permissionLevels.length = 0;
  newPermissionLevels.forEach((permission) => {
    permissionLevels.push(permission);
  });
}

const expiryTime = [
  { title: "30 Mins", value: "30" },
  { title: "1 Hour", value: "60" },
  { title: "2 Hours", value: "120" },
  { title: "3 Hours", value: "180" },
];
onMounted(() => {
  getData();
  removePermissionLevels();
});

const newAccount: NewAccount = reactive({});

const alertTxt = ref(false);
const creating = ref(false);
const accountCreated = ref(false);
var snackbar = ref(false);
var snackbarText = ref("My timeout is set to 2000.");
var timeout = 2000;

async function createAccount() {
  alertTxt.value = false;
  if (!newAccount.mdmServerID) {
    alertTxt.value = "Please select an MDM Server";
    return;
  }
  if (!newAccount.permissionLevel) {
    alertTxt.value = "Please select a Permission Level";
    return;
  }
  if (!newAccount.expireInMins) {
    alertTxt.value = "Please select an Expiry Time";
    return;
  }

  creating.value = true;
  loading.value = true;
  try {
    const result = await apiQuery("ELA", "ela/createTemporaryJamfAccount", {
      mdmServerID: newAccount.mdmServerID,
      permissionLevel: newAccount.permissionLevel,
      expireInMins: newAccount.expireInMins,
    });
    if (result.error) {
      alertTxt.value = result.error;
      if (result.error == "User has too many active accounts") {
        alertTxt.value =
          "You have too many active accounts, disable one first from the accounts tab";
      }
      creating.value = false;
      loading.value = false;
      return;
    }
    if (result.username) {
      accountCreated.value = true;
      newAccount.username = result.username;
      newAccount.password = result.password;
      newAccount.url = getJamfURL(
        result.username,
        newAccount.mdmServerID ?? ""
      );
    }
    // Check for Failover URL in response
    // Username cannot be pre-filled due to bug with Jamf Pro
    if (result.failoverUrl) {
      newAccount.failoverUrl = result.failoverUrl;
    }

    getData();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.response) {
      if (error.response.status == 401) {
        console.log("NOT AUTHORISED");
        alertTxt.value = "Not Authorised";
      } else {
        console.log(error);
        alertTxt.value = "Error Requesting Account";
      }
    } else {
      console.log(error);
      alertTxt.value = "Error Requesting Account";
    }
  }
  creating.value = false;
  loading.value = false;
}

function alertBar(message: string) {
  snackbarText.value = message;
  snackbar.value = true;
}

function getJamfURL(username: string, mdmServerID: string) {
  var url;
  mdmServers.forEach((mdmServer) => {
    if (mdmServer._id == mdmServerID) {
      url = mdmServer.url + "?username=" + username;
    }
  });
  return url;
}

function copyText(text?: string) {
  navigator.clipboard.writeText(text || "");
}

const accountHeaders = [
  { text: "Setup Time", value: "setupTime", sortable: true },
  {
    text: "Removal Time",
    value: "scheduledRemovalTime",
    sortable: true,
  },
  { text: "MDM Server", value: "mdmServerName", sortable: true },
  { text: "Created By", value: "createdBy", sortable: true },
  { text: "Permission Level", value: "permissionLevel", sortable: true },
  { text: "Removed", value: "removed", sortable: true },
  { text: "Blocking", value: "blockOtherAccounts", sortable: true },
  { text: "Actions", value: "actions" },
];

const displayConfirm = ref(false);
const disableAccountID = ref("");
function disableAccount(account: tempAccountRecords) {
  disableAccountID.value = account._id;
  displayConfirm.value = true;
}

const loading = ref(false);
async function confirmDisable() {
  console.log("Disabling Account");
  loading.value = true;
  displayConfirm.value = false;
  await apiQuery("ELA", "ela/TemporaryJamfAccountActions", {
    apiAction: "deactivateAccount",
    tempAccountId: disableAccountID.value,
  });
  await getData();
  loading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[31] || (_cache[31] = _createElementVNode("h2", null, "Temporary Admin Accounts", -1)),
    _createVNode(_component_v_tabs, {
      modelValue: selectedTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTab).value = $event)),
      color: "#e7541e"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "createAccount" }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [
            _createTextVNode("Create Account")
          ])),
          _: 1
        }),
        (showAccountsTab.value)
          ? (_openBlock(), _createBlock(_component_v_tab, {
              key: 0,
              value: "accounts"
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createTextVNode("Accounts")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: selectedTab.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedTab).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, {
          value: "createAccount",
          class: "pt-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "pa-2" }, {
              default: _withCtx(() => [
                (!accountCreated.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(VSelectSearch, {
                        items: mdmServers,
                        itemTitle: "name",
                        itemValue: "_id",
                        "no-data-textaasd": "Loading please wait...",
                        label: "Select MDM Server",
                        activateSearch: "",
                        modelValue: newAccount.mdmServerID,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newAccount.mdmServerID) = $event))
                      }, null, 8, ["items", "modelValue"]),
                      _createVNode(_component_v_select, {
                        label: "Permission Level Required",
                        items: permissionLevels,
                        modelValue: newAccount.permissionLevel,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newAccount.permissionLevel) = $event))
                      }, null, 8, ["items", "modelValue"]),
                      _createVNode(_component_v_select, {
                        label: "Account Expires in...",
                        items: expiryTime,
                        modelValue: newAccount.expireInMins,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newAccount.expireInMins) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field, {
                        label: "Change Reference",
                        modelValue: newAccount.changeReference,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newAccount.changeReference) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_btn, {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (createAccount())),
                        disabled: creating.value,
                        loading: loading.value
                      }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode("Create")
                        ])),
                        _: 1
                      }, 8, ["disabled", "loading"]),
                      (alertTxt.value)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 0,
                            class: "pt-3",
                            color: "error"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(alertTxt.value), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[22] || (_cache[22] = _createElementVNode("h2", null, "Account has been created", -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("div", null, [
                        _cache[18] || (_cache[18] = _createElementVNode("h3", null, "Username", -1)),
                        _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(newAccount.username) + " ", 1),
                        _createVNode(_component_v_icon, {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (
                copyText(newAccount.username), alertBar('Username Coppied')
              )),
                          icon: "mdi-content-copy"
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _cache[20] || (_cache[20] = _createElementVNode("h3", null, "Password", -1)),
                        _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(newAccount.password) + " ", 1),
                        _createVNode(_component_v_icon, {
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (
                copyText(newAccount.password), alertBar('Password Coppied')
              )),
                          icon: "mdi-content-copy"
                        })
                      ]),
                      _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                      (!newAccount.failoverUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: newAccount.url,
                            target: "_blank"
                          }, "Open Jamf Pro", 8, _hoisted_1))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: newAccount.failoverUrl,
                            target: "_blank"
                          }, "Open Jamf Pro", 8, _hoisted_2))
                    ], 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, {
          value: "accounts",
          class: "pt-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "pa-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  style: {"height":"35px"},
                  class: "text-right d-flex"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_checkbox, {
                          class: "text-right shrink",
                          label: "Show All",
                          modelValue: showAllRecords.value,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showAllRecords).value = $event)),
                          density: "compact"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_EasyDataTable, {
                  items: accounts,
                  headers: accountHeaders,
                  loading: loading.value,
                  "empty-message": "No accounts",
                  "theme-color": "#e7541e"
                }, {
                  "item-actions": _withCtx((item) => [
                    _createVNode(_component_v_icon, {
                      onClick: ($event: any) => (disableAccount(item))
                    }, {
                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                        _createTextVNode("mdi-delete")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  "item-setupTime": _withCtx((item) => [
                    _createTextVNode(_toDisplayString(item.setupTimeFormatted), 1)
                  ]),
                  "item-scheduledRemovalTime": _withCtx((item) => [
                    _createTextVNode(_toDisplayString(item.scheduledRemovalTimeFormatted), 1)
                  ]),
                  _: 1
                }, 8, ["items", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_dialog, {
          modelValue: displayConfirm.value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((displayConfirm).value = $event)),
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                    _createTextVNode("Confirm Disable Account")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                    _createTextVNode("Please confirm you wish to disable this account.")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (displayConfirm.value = false))
                    }, {
                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                        _createTextVNode("Cancel")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (confirmDisable()))
                    }, {
                      default: _withCtx(() => _cache[29] || (_cache[29] = [
                        _createTextVNode("Disable")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _unref(snackbar),
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(snackbar) ? (snackbar).value = $event : snackbar = $event)),
      timeout: _unref(timeout)
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          color: "blue",
          variant: "text",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_isRef(snackbar) //@ts-ignore
 ? snackbar.value = false : snackbar = false))
        }, {
          default: _withCtx(() => _cache[30] || (_cache[30] = [
            _createTextVNode(" Close ")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(snackbarText)) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "timeout"])
  ], 64))
}
}

})